import { BiocharProduction } from './BiocharProduction'
import { FeedstockDelivered } from './FeedstockDelivered'
import { TelematicsActivityData } from './TelematicsActivityData'
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import moment from 'moment'
import BookmarkOutlinedIcon from '@mui/icons-material/BookmarkOutlined';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import {
    Button,
    Grid,
    Typography,
    Alert,
    Box,
    Divider
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getCarRppbProjects, getCompanyUserCarRppbs } from '../../../../actions/tigercat-burns/tigercat-base-actions';
import { DataAccordion } from '../shared-components/DataAccordion';

export default function TCDashboard({ userData, isOpen }) {
    const [hide, setHide] = useState(false);
    const [hideProjects, setHideProjects] = useState(false);
    const scrollId = 'scroll-target-1';
    const carRppbProjects = useSelector(state => state.tigercatBurnsBaseReducer.carRppbProjects.data)
    const carRppbs = useSelector(state => state.tigercatBurnsBaseReducer.carRppbs.data)
    const deepBlue = '#212746'
    const [activeCarRppb, setActiveCarRppb] = useState(null);
    const [activeCarRppbProject, setActiveCarRppbProject] = useState(null);
    const navigate = useNavigate()
    const dispatch = useDispatch();

    const userCompanyId = userData?.tigercatBurnsUser?.companyId;

    useEffect(() => {
        if (userCompanyId)
            dispatch(getCompanyUserCarRppbs(userCompanyId))
    }, [dispatch, userCompanyId])

    useEffect(() => {
        if (carRppbs?.length > 0 && !activeCarRppb) {
            const firstCarRppb = carRppbs[0];
            setActiveCarRppb(firstCarRppb);
            dispatch(getCarRppbProjects(firstCarRppb.id));
        }
    }, [carRppbs, activeCarRppb, dispatch]);

    useEffect(() => {
        const element = document.getElementById('scroll-target-1');
        if (element && activeCarRppb) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }, [activeCarRppb, activeCarRppbProject]);

    const handleSetActiveCarRppb = (carRppb) => {
        setActiveCarRppb(carRppb)
        dispatch(getCarRppbProjects(carRppb.id))
    }

    return (
        <>
            <Box sx={{ mb: 2 }}>
                <Typography sx={{ color: deepBlue }}>
                    Click the {isOpen
                        ? <ChevronLeftIcon sx={{ verticalAlign: 'bottom' }} />
                        : <MenuIcon sx={{ verticalAlign: 'bottom' }} />} button at the top left to
                    {isOpen
                        ? ' collapse'
                        : ' expand'} the sidebar.
                </Typography>
            </Box>
            <Typography variant="h4" component="h4" sx={{ mb: 2 }}>
                Earth Foundries Carbonization
            </Typography>
            <Typography variant="body1" component="p" sx={{ mb: 3 }}>
                You have access to the Earth Foundries Operations App. Click on the link below to access the biochar data management tool.
            </Typography>
            <Button variant="contained" onClick={() => navigate('/car-reporting')}>
                Biochar Data Management Tool
            </Button>
            <Alert sx={{ mt: 3 }} severity='warning'>
                Please email wihan@mycharr.app should you have any questions or need assistance.
            </Alert>
            <Divider sx={{ my: 3 }} />
            <DataAccordion title="CAR RPPBs" show={!hide} handleChange={() => setHide(!hide)}>
                <Grid xs={12} display="flex" alignContent={'space-between'} flexWrap={'wrap'}>
                    {carRppbs?.map((carRppb, index) => {
                        return (
                            <Button
                                sx={{ mr: 2 }}
                                key={index}
                                variant={carRppb.id === activeCarRppb?.id ? 'contained' : 'outlined'}
                                color='primary'
                                onClick={() => handleSetActiveCarRppb(carRppb)}>
                                {carRppb.reportingEntityName}
                            </Button>
                        )
                    })}
                </Grid>
            </DataAccordion>
            {
                activeCarRppb &&
                <DataAccordion title="Projects" show={!hideProjects} handleChange={() => setHideProjects(!hideProjects)}>
                    <Grid container>
                        <Typography variant='h5' component='h4' sx={{ mb: 3 }} id="scroll-target-1">
                            CAR RPPB Projects
                        </Typography>
                        <Grid xs={12} display="flex" alignContent={'space-between'} flexWrap={'wrap'} mb={'1rem'}>
                            {carRppbProjects?.map((project, index) => {
                                return (

                                    <Box className="biochar-project" key={index}
                                        sx={activeCarRppbProject?.id === project.id && { background: 'linear-gradient(to bottom right, #535988, #313551)', color: '#FFF', boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px' }}
                                        onClick={() => {
                                            setActiveCarRppbProject(project)
                                        }}>
                                        <Typography sx={{ fontSize: '18px' }}>{activeCarRppbProject?.id === project.id ? <BookmarkOutlinedIcon sx={{ mb: '-7px' }} /> : <BookmarkBorderOutlinedIcon sx={{ mb: '-7px' }} />} {project.id}</Typography>
                                        <Typography sx={project.projectName ? { fontSize: '14px' } : { visibility: 'hidden' }} mt={3}><strong>Project Name:</strong> {project.projectName}</Typography>
                                        <Typography sx={{ fontSize: '14px' }}><strong>Date Created:</strong> {moment(project.createdAt).format('MM-DD-YY')}</Typography>
                                    </Box>
                                )
                            })}
                        </Grid>
                    </Grid>
                </DataAccordion>
                // <Accordion defaultExpanded>
                //     <AccordionSummary
                //         expandIcon={<ExpandMoreIcon />}
                //         aria-controls="panel1a-content"
                //         id="panel1a-header"
                //         onClick={() => setHideProjects(!hideProjects)}
                //     >
                //         <Typography>{hideProjects ? "Hide" : "Expand"} Projects</Typography>
                //     </AccordionSummary>
                //     <AccordionDetails>
                //         <Grid container>
                //             <Typography variant='h5' component='h4' sx={{ mb: 3 }} id="scroll-target-1">
                //                 CAR RPPB Projects
                //             </Typography>
                //             <Grid xs={12} display="flex" alignContent={'space-between'} flexWrap={'wrap'} mb={'1rem'}>
                //                 {carRppbProjects?.map((project, index) => {
                //                     return (

                //                         <Box className="biochar-project" key={index}
                //                             sx={activeCarRppbProject?.id === project.id && { background: 'linear-gradient(to bottom right, #535988, #313551)', color: '#FFF', boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px' }}
                //                             onClick={() => {
                //                                 setActiveCarRppbProject(project)
                //                             }}>
                //                             <Typography sx={{ fontSize: '18px' }}>{activeCarRppbProject?.id === project.id ? <BookmarkOutlinedIcon sx={{ mb: '-7px' }} /> : <BookmarkBorderOutlinedIcon sx={{ mb: '-7px' }} />} {project.id}</Typography>
                //                             <Typography sx={project.projectName ? { fontSize: '14px' } : { visibility: 'hidden' }} mt={3}><strong>Project Name:</strong> {project.projectName}</Typography>
                //                             <Typography sx={{ fontSize: '14px' }}><strong>Date Created:</strong> {moment(project.createdAt).format('MM-DD-YY')}</Typography>
                //                         </Box>
                //                     )
                //                 })}
                //             </Grid>
                //         </Grid>
                //     </AccordionDetails>
                // </Accordion>
            }

            <BiocharProduction activeCarRppbProject={activeCarRppbProject} activeCarRppb={activeCarRppb} scrollId={scrollId} />
            {activeCarRppbProject && <Divider sx={{ my: 3 }} />}
            <FeedstockDelivered activeCarRppbProject={activeCarRppbProject} activeCarRppb={activeCarRppb} />
            {activeCarRppbProject && <Divider sx={{ my: 3 }} />}
            <TelematicsActivityData activeCarRppbProject={activeCarRppbProject} activeCarRppb={activeCarRppb} />
        </>
    )
}